/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';

export const subtitleSearchMatchSchema = z.object({
  collectionId: z.number(),
  collectionTitle: z.string(),
  subtitleId: z.number(),
  entryIndices: z.array(z.number()),
  startMs: z.number(),
  endMs: z.number(),
  transcript: z.string(),
  alreadyExists: z.boolean(),
});

export type ISubtitleSearchMatch = z.infer<typeof subtitleSearchMatchSchema>;

export const searchSubtitlesForChallengeV1DataSchema = z.object({
  searchTerms: z.array(z.string()),
  matches: z.array(subtitleSearchMatchSchema),
});

export type ISearchSubtitlesForChallengeV1Data = z.infer<
  typeof searchSubtitlesForChallengeV1DataSchema
>;

export const searchSubtitlesForChallengeV1ResponseSchema = createApiResponseSchema(
  searchSubtitlesForChallengeV1DataSchema,
) as z.ZodSchema<IAPI<ISearchSubtitlesForChallengeV1Data>>;

export type ISearchSubtitlesForChallengeV1Response = IAPI<ISearchSubtitlesForChallengeV1Data>;
